<template>
  <div class="card mx-3" style="width: 18rem;">
    <div class="card-body" style="padding-left: 7px;padding-right: 7px;">
      <p><h5 class="card-title" >{{ call.name }}</h5></p>
      <p class="card-subtitle mb-2 text-muted">Período de inscripción</p>
      <p class="card-text">Desde: {{ call.start_date | moment("DD/MM/YY - h:mm")}}hs</p>
      <p class="card-text">Hasta: {{ call.end_date | moment("DD/MM/YY - h:mm")}}hs</p>
      <a class="btn btn-primary" @click="checkFormType()">Inscribirse</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["proposal","call"],
  data() {      
    return {};   
  },   
  methods: {
    checkFormType() {
      this.$router.push({name: 'Formulario', params: { proposal:this.proposal,call: this.call } });
    },
  },
};
</script>